import { useMediaQuery } from "react-responsive";

export const useBigScreen = () => useMediaQuery({ query: '(min-width: 992px)' })